<template>

    <v-footer :absolute="false" class="footer" color="primary" dark
             style="position: absolute;bottom: 0;width: 100%">
        <v-spacer></v-spacer>
     <div class="font-weight-regular">©2020 Global Psytech Sdn. Bhd.</div>
   </v-footer>


<!--    <v-footer-->
<!--            padless-->
<!--            :fixed="true"-->
<!--            :inset="true"-->
<!--            :absolute="false" class="footer" color="primary" dark style="position: absolute;bottom: 0;width: 100%"-->
<!--    >-->
<!--        <v-row-->
<!--                justify="center"-->
<!--                no-gutters-->
<!--        >-->
<!--            <BottomNavigation style="background-color: white!important;" class="hidden-md-and-up" ></BottomNavigation>-->
<!--            <v-col-->
<!--                    class="primary  py-4 text-center hidden-md-and-up white&#45;&#45;text"-->
<!--                    cols="12"-->
<!--            >-->
<!--                <div class="font-weight-regular">Powered by Global Psytech</div>-->
<!--            </v-col>-->
<!--            <v-col-->
<!--                    class="primary  py-4 pl-1 text-right hidden-sm-and-down white&#45;&#45;text"-->
<!--                    cols="12"-->
<!--            >-->
<!--                <div class="font-weight-regular">Powered by Global Psytech</div>-->
<!--            </v-col>-->
<!--        </v-row>-->
<!--    </v-footer>-->
</template>

<script>
    // import BottomNavigation from '../components/BottomNavigation'

    export default {
        components:{
            // BottomNavigation
        },
  name: 'Footer'
}
</script>

<style scoped>

</style>
